<div [className]="isConfirming ? 'container tiny confirming' : 'container tiny factoring'">
    <p>
        {{isConfirming ? 'Confirming' : 'Factoring'}}
    </p>
</div>